import { TbX } from "solid-icons/tb";
import { createSignal, Show } from "solid-js";
import { isServer } from "solid-js/web";
import { DownloadStartedModal } from "~/components/shared/DownloadStartedModal";
import { PlatformIcon } from "~/components/shared/PlatformIcon";
import { chiefDownloadHref, chiefOSLabel, hasChiefBuild } from "~/lib/chiefDownload";
import { trackFeature } from "~/lib/trackFeature";
import { useOS } from "~/lib/useOS";

const REBRAND_DISMISSED_KEY = "chief-rebrand-banner-dismissed";

export const RebrandBanner = () => {
  const os = useOS();
  // Reading localStorage throws where site data is blocked (cookies off, third-party iframe).
  const readDismissed = () => {
    try {
      return localStorage.getItem(REBRAND_DISMISSED_KEY) === "true";
    } catch {
      return false;
    }
  };
  const [dismissed, setDismissed] = createSignal(!isServer && readDismissed());
  const [showDownloadStarted, setShowDownloadStarted] = createSignal(false);

  const dismiss = () => {
    trackFeature({ feature: "rebrand_banner", action: "dismiss", via: "button" });
    setDismissed(true);
    try {
      localStorage.setItem(REBRAND_DISMISSED_KEY, "true");
    } catch {
      // The banner stays dismissed for this page view only.
    }
  };

  return (
    <>
      <Show when={!dismissed() && hasChiefBuild(os())}>
        <div class="border-b border-accent/30 bg-accent/10 px-3 py-2">
          <div class="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1">
            <span class="text-xs font-medium text-amber-800 dark:text-amber-300">
              Chief is your AI-Native Command Center.
            </span>
            <a
              href={chiefDownloadHref(os())}
              onClick={(e) => {
                e.preventDefault();
                trackFeature({ feature: "rebrand_banner", action: "download", via: "button" });
                setShowDownloadStarted(true);
              }}
              class="inline-flex items-center gap-1.5 text-xs font-medium text-amber-800 transition-opacity hover:opacity-90 dark:text-amber-300"
            >
              <PlatformIcon os={os()} class="size-3.5 shrink-0" />
              <span class="underline underline-offset-2">Download for {chiefOSLabel(os())}</span>
            </a>
            <span class="text-xs font-medium text-amber-800 dark:text-amber-300">
              and use for Zoom, Team, G-Meet, phone calls and in-person meetings.
            </span>
            <button
              type="button"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                dismiss();
              }}
              class="cursor-pointer rounded p-0.5 text-amber-800 hover:bg-accent/20 dark:text-amber-300"
              aria-label="Dismiss"
            >
              <TbX class="size-3.5" />
            </button>
          </div>
        </div>
      </Show>
      <DownloadStartedModal
        open={showDownloadStarted()}
        href={chiefDownloadHref(os())}
        os={os()}
        onClose={() => setShowDownloadStarted(false)}
      />
    </>
  );
};
